<template>
  <div class="discount-page">
    <div class="discount-inner" v-if="discountData">
      <div class="info">
        <div class="logo">
          <img src="static/logos/lcp-logo.svg" alt="Low Carb Program" />
        </div>
        <div class="text">
          <h1 v-if="!isLoading">Get {{ discountData.discount }}% off</h1>
          <span>12 months of Low Carb Program</span>
          <ul>
            <li>
              Embrace life-changing low carb lifestyle with expert-led education
            </li>
            <li>
              Group and one-to-one virtual meetups with Low Carb Program experts
            </li>
            <li>
              Browse 1,837 recipes and tailor meal plans to your preferences
            </li>
          </ul>
          <div class="testimonial">
            <img src="static/chrissy-after.jpg" alt="Chrissy" />
            <span
              >“My start weight was 105kg (16st 8 lbs) and now I weigh 80kg
              (12st 9 lbs). I’ve had to buy a new wardrobe – I bought two pairs
              of trousers last year that were too tight and now they’re falling
              off me! I also have type 2 diabetes and it has helped my blood
              sugars to come down”</span
            >
          </div>
        </div>
      </div>
      <div class="pricing">
        <mu-flexbox
          v-if="isLoading"
          justify="center center"
          align="center center"
          style="height: 316px"
        >
          <mu-flexbox-item align="center">
            <mu-circular-progress :size="46"></mu-circular-progress>
            <br />
            <span v-text="$t('message.loadingText')"></span>
          </mu-flexbox-item>
        </mu-flexbox>
        <div v-if="!isLoading" class="pricing-inner">
          <div class="receipt-row">
            <div class="receipt-detail">
              <p>Original cost per year</p>
            </div>
            <div class="receipt-detail">
              <p>£{{ originalCost }}</p>
            </div>
          </div>
          <div class="receipt-row">
            <div class="receipt-detail">
              <p>Discount ({{ discountData.discount }}%)</p>
            </div>
            <div class="receipt-detail">
              <p>-£{{ usersDiscount }}</p>
            </div>
          </div>
          <div class="separator"></div>
          <div class="receipt-row">
            <div class="receipt-detail">
              <p class="bolder-left">Cost per year</p>
            </div>
            <div class="receipt-detail">
              <p class="bolder-right">£{{ calculatedCost }}</p>
            </div>
          </div>
          <p style="color: #5b617c; margin-top: 1rem; font-size: 14px">
            *£{{ calculatedCost }} for one year, renewing at £{{
              originalCost
            }}, billed annually
          </p>

          <a @click="submitDiscount()" class="paypal-button w-inline-block"
            ><div class="slider-right">Subscribe now</div></a
          >
          <stripe-checkout
            ref="sessionCheckoutRef"
            :pk="publishableKey"
            :session-id="sessionId"
          />
          <p class="greyText">
            The yearly membership gives you unlimited access to the Low Carb
            Program's entire library of content and virtual events. You will be
            charged £{{ calculatedCost }} for a 1 year subscription that will
            renew at £{{ originalCost }}, billed annually.
          </p>
          <p class="greyText">
            You may cancel your subscription at any time by going to your
            Profile and following the instructions on the 'Manage Subscription'
            page.
          </p>
          <p class="greyText account">
            Upgrading account: <span>{{ discountData.email }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config";
import PaymentApi from "../../api/Payment";
import AuthenticationManager from "../../helpers/AuthenticationManager";
import _ from "lodash";
import Config from "../../config";
import { StripeCheckout } from "@vue-stripe/vue-stripe";

export default {
  name: "Discount",
  components: {
    StripeCheckout,
  },
  data() {
    return {
      originalCost: 69.99,
      discountData: {},
      subscription: null,
      publishableKey: `${Config.stripePublishableKey}`,
      sessionId: null,
      isLoading: true,
    };
  },
  methods: {
    getPackageAndPay() {
      let self = this;
      PaymentApi.getPayPalSubscriptionDetails().then((response) => {
        let packages = response.data.packages;

        const discountKey =
          packages["yearly-subscription-thirty-limited-time-plan"].key;


        PaymentApi.getUuid().then((response) => {
          const uuid = response.data.uuid;
          if (!uuid.length) {
            throw "uuid cannot be blank";
          }
          setTimeout(() => {
            window.location.href =
              self.Config("apiUrl") +
              `paypal/subscription/express-checkout?package=${discountKey}&uuid=${uuid}`;
          }, 800);
        });
      });
    },
    getDiscount() {
      let self = this;
      axios
        .get(config.apiUrl + `stripe/discount/${self.$route.query.slug}/`)
        .then(function (response) {
          self.discountData = response.data.data.user;
          self.sessionId = response.data.data.session.session_id;
        })
        .catch((err) => {
          // redirect to dashboard
          self.$router.push({
            path: `/dashboard`
          });
        })
        .finally(() => {
          self.isLoading = false;
        });
    },
    submitDiscount() {
      let self = this;
      self.$refs.sessionCheckoutRef.redirectToCheckout();
      // if (AuthenticationManager.hasToken()) {
      //   if (_.includes(AuthenticationManager.parseJwt().scope, 'unsubscribed_tasks')) {
      //     self.getPackageAndPay();
      //   } else {
      //     self.$router.push({
      //       path: `/dashboard`
      //     });
      //   }
      // } else {
      //   self.$router.push({
      //     path: `/login`
      //   });
      // }
    },
    Config(key) {
      return Config[key];
    },
  },
  mounted() {
    let self = this;
    self.getDiscount();
  },
  computed: {
    usersDiscount: function () {
      let self = this;
      let discount = self.discountData.discount / 100;
      return (self.originalCost * discount).toFixed(2);
    },
    calculatedCost: function () {
      let self = this;
      return (self.originalCost - self.usersDiscount).toFixed(2);
    },
  },
};
</script>

<style lang="less" scoped>
.paypal-button {
  width: 100%;
}
.paypal-button:hover {
  cursor: pointer;
}

.w-inline-block {
  max-width: 100%;
  display: inline-block;
}
.slider-right {
  width: 100%;
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 4px;
  background-color: #0a0;
  -webkit-transition: 0.2s;
  transition: 0.2s;
  font-family: poppins, sans-serif;
  color: #fff;
  font-size: 1.2em;
  font-weight: 500;
  text-align: center;
}
.discount-page {
  background: #fff;
  .discount-inner {
    display: flex;
    flex-direction: row;
    align-content: center;
    @media screen and (max-width: 995px) {
      display: block;
    }
    .info {
      width: 40%;
      -webkit-box-flex: 0;
      -webkit-flex: 0 0 auto;
      -ms-flex: 0 0 auto;
      flex: 0 0 auto;
      background-image: -webkit-gradient(
          linear,
          left top,
          left bottom,
          from(rgba(0, 0, 0, 0.73)),
          to(rgba(0, 0, 0, 0.73))
        ),
        url("../../../static/special-discount-bg.jpeg");
      background-image: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.73),
          rgba(0, 0, 0, 0.73)
        ),
        url("../../../static/special-discount-bg.jpeg");
      background-position: 0 0, 0 0;
      background-size: auto, cover;
      @media screen and (max-width: 995px) {
        display: block;
        width: 100%;
      }
      .logo {
        border-bottom: 1px solid hsla(0, 0%, 100%, 0.08);
        padding: 60px 40px;
        img {
          width: 200px;
        }
      }

      .text {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 3rem;
        height: 80%;
        h1 {
          font-size: 3rem;
          font-weight: 600;
          color: #fff;
        }
        span {
          color: #fff;
          font-weight: 500;
          font-size: 1rem;
          line-height: 1.4;
        }
        ul {
          padding-left: 0;
          li {
            margin: 10px 0;
            padding-left: 36px;
            background-image: url("../../../static/pw/tick_active.svg");
            background-repeat: no-repeat;
            background-position: 0 20%;
            background-size: 1.3rem;
            font-weight: 500;
            font-size: 1.1rem;
            line-height: 1.4;
            list-style-type: none;
            color: #fff;
          }
        }
        .testimonial {
          display: flex;
          flex-direction: row;
          padding: 12px;
          img {
            height: 40px;
            margin-right: 12px;
            border-radius: 8px 8px 1rem;
          }
        }
      }
    }
    .pricing {
      position: relative;
      display: -webkit-box;
      display: -webkit-flex;
      display: -ms-flexbox;
      display: flex;
      overflow: auto;
      width: 60%;
      height: 100vh;
      margin-left: auto;
      padding: 20px 3% 100px;
      -webkit-box-pack: center;
      -webkit-justify-content: center;
      -ms-flex-pack: center;
      justify-content: center;
      -webkit-box-align: center;
      -webkit-align-items: center;
      -ms-flex-align: center;
      align-items: center;
      -webkit-align-self: center;
      -ms-flex-item-align: center;
      align-self: center;
      -webkit-box-flex: 0;
      -webkit-flex: 0 auto;
      -ms-flex: 0 auto;
      flex: 0 auto;
      background-color: #fff;
      @media screen and (max-width: 995px) {
        display: block;
        width: 100%;
        height: auto;
        padding-bottom: 20px;
        padding-top: 40px;
      }
      .pricing-inner {
        width: 600px;
        margin: 0 auto;
        .receipt-row {
          display: flex;
          justify-content: space-between;
          margin: 8px 0;
          p {
            color: #000;
            font-size: 1rem;
          }
          .bolder-left {
            font-size: 1.3rem;
            line-height: 1.4;
            font-weight: 600;
          }
          .bolder-right {
            font-size: 1.6rem;
            line-height: 1.4;
          }
        }
        .separator {
          width: 100%;
          height: 24px;
          margin-top: 24px;
          border-top: 2px dashed rgba(91, 97, 124, 0.25);
        }
        .pp-button {
          background-color: #ffc439;
          width: 100%;
          margin-top: 1.3rem;
          margin-bottom: 1.5rem;
          padding-top: 20px;
          padding-bottom: 10px;
          border-radius: 4px;
          -webkit-transition: 0.2s;
          transition: 0.2s;
          font-family: poppins, sans-serif;
          color: #fff;
          font-size: 1.2em;
          font-weight: 500;
          text-align: center;
          display: block;
          cursor: pointer;
          &:hover {
            background-color: #f1ba38;
          }
        }
        .greyText {
          color: #5b617c;
          font-size: 14px;
          text-align: center;
          font-weight: 500;
          &.account {
            margin-top: 1.7rem;
            span {
              color: #0179d5;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// Discount.vue?60d621c4